import styled from 'styled-components'
import { Box } from '../../new/core-components/box'

import { Card } from '../card'

export const Search = styled(Card)`
  position: relative;
  z-index: 1;
  list-style: none;
  outline: none;
`

export const SearchListContainer = styled(Box)`
  list-style: none;
`
